import { defineStore } from 'pinia';

export const usePrefsStore = defineStore('preferences', {
    state: () => {
        return {
            limit: 24
        }
    },
    actions: {
        setPref(key, value) {
            this[key] = value;
        }
    }
})